<template>
   <div id="dvSecciones" :class="template">
      <span class="title">{{title}}</span>
      <section class="section">
         <div class="item" v-for="(value, index) in data.items" :key="index" v-if="tipo === '' || value.tipo === tipo">
            <div class="dvImg">
               <img :src="require(`@/assets/fabrica/${value.imagen}`)" />
            </div>
            <div class="dvCard">
               <div class="dvCardTitle">
                  <span>{{categoria ? value.categoria : ''}} <span>{{value.nombre}} - {{value.serie}}</span></span>
                  <span>Desde:  {{currency(value.precio)}}</span>
               </div>
               <div class="dvCardInfo">
                  <div>
                     <i class="fas fa-microchip"></i>
                     <div>
                        <span>Procesador</span>
                        <span>{{value.procesador}}</span>
                     </div>
                  </div>
                  <div>
                     <i class="fas fa-memory"></i>
                     <div>
                        <span>Memoria Ram</span>
                        <span>{{value.ram}}</span>
                     </div>
                  </div>
                  <div>
                     <i class="fas fa-paint-brush"></i>
                     <div>
                        <span>Gráficos</span>
                        <span>{{value.grafica}}</span>
                     </div>
                  </div>
                  <div>
                     <i class="fas fa-hdd"></i>
                     <div>
                        <span>Almacenamiento</span>
                        <span>{{value.storage}}</span>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
   </div>
</template>

<script>
    import Card from "./Card";
    import {mapActions, mapMutations, mapState} from 'vuex'

    export default {
        name: "ViewCard",
        components: {Card},
        computed: mapState([
            'template',
        ]),
        props: {
            data: {
                type: Object,
                required: true
            },
            title: String,
            tipo: {
                type: String,
                default: ""
            },
            categoria: {
                type: Boolean,
                default: false
            },
        },
        methods: {
            currency(value) {
                return formatCurrency(value);
            }
        }
    }
</script>

<style scoped lang="scss">
   @import "../style/base";

   #dvSecciones {
      padding: 20px;
      @include flexColumn;
      @include absoluteCenter;
      margin-top: 30px;

      & .title {
         @include Quicksand;
         @include fontFormat(25px, 600, #FFFFFF);
         margin-bottom: 100px;
      }

      & .section {
         @include flexRow;
         flex-wrap: wrap;
         justify-content: space-around;
         max-width: 1480px;

         & .item {
            @include flexColumn;
            color: #ffffff;
            /*background: #f6d54b;*/
            min-width: 200px;
            max-width: 350px;
            margin: 10px 10px 70px;
            box-shadow: 0px 0px 10px -2px #f6d54b;

            &:HOVER {
               box-shadow: 0px 0px 10px 2px #f6d54b;
            }

            & .dvImg {
               position: relative;
               height: 100px;
               & > img {
                  position: absolute;
                  height: 150px;
                  left: 30%;
                  top: -55px;
               }
            }


            & .dvCard {
               @include flexColumn;
               & > div {
                  &.dvCardTitle {
                     @include flexColumn;
                     justify-content: center;
                     align-items: center;

                     & > span {
                        line-height: 1.2;
                        &:first-of-type {
                           @include fontFormat(18px, 700, #ffffff )
                        }
                        &:last-of-type {
                           @include fontFormat(16px, 500, #ffffff )
                        }
                     }
                  }

                  &.dvCardInfo {
                     @include flexRow;
                     flex-wrap: wrap;
                     justify-content: space-evenly;

                     & > div {
                        @include flexRow;
                        align-items: center;
                        padding: 5px;
                        width: 175px;


                        & i {
                           font-size: 20px;
                           padding: 10px;
                           width: 45px;
                        }

                        & > div {
                           @include flexColumn;
                        }
                     }
                  }
               }
            }
         }
      }

       &.white {
           & .title {
               color: #000000;
           }
           & .section {
               & .item {
                   color: $cieBlack;
                   box-shadow: 1px 1px 6px -2px #444444;

                   &:HOVER {
                       box-shadow: 4px 4px 12px -4px #444444
                   }
                   & .dvCard {
                       & > div {
                           &.dvCardTitle {
                               & > span {
                                   color: $cieBlack;
                               }
                           }
                       }
                   }
               }
           }
       }
   }

</style>